import { render, staticRenderFns } from "./LettersList.vue?vue&type=template&id=bd288e80&scoped=true&"
import script from "./LettersList.vue?vue&type=script&lang=ts&"
export * from "./LettersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd288e80",
  null
  
)

export default component.exports